module.exports = __webpack_public_path__ + "img/abstract.a4fcf784.webp";